export type ErrorTypes =
  | 'required'
  | 'email'
  | 'minlength'
  | 'invalidDate'
  | 'invalidYear'
  | 'passwordMismatch'
  | 'pattern';

export const ERROR_MESSAGES: { [key: string]: (...args: any) => string } = {
  required: (formControlName: string) => `Il campo ${formControlName} è obbligatorio.`,
  email: () => `Questo non è un indirizzo e-mail valido.`,
  minlength: (formControlName, requirement) =>
    `${formControlName} deve essere almeno ${requirement} caratteri.`,
  invalidDate: () => `Questa non è una data valida.`,
  invalidYear: () => `Date of Birth should be after year 1900.`,
  passwordMismatch: () => 'Le password non coincidono.',
  pattern: (formControlName: string) => `Il campo ${formControlName} non rispetta il formato richiesto.`
};
